/*
 * سدر الخليج: تبويبا «السلة | المفضلة» في درج السلة (STR-159)
 *
 * التبويب المفتوح خاصية data-sedr-tab على <cart-drawer>. القالب يستبدل محتوى الدرج عند كل تغيّر في السلة
 * ولا يستبدل العنصر نفسه، فتبقى الخاصية، والإظهار والإخفاء في sedr-cart-tabs.css.
 * لا يُمسّ كود السلة في القالب: الفتح والإغلاق بدوال الدرج نفسها (show)، وما هنا يضبط التبويب فقط.
 *
 * العناصر:
 *   <sedr-cart-tabs>       زرّا التبويب مكان عنوان السلة
 *   <sedr-wishlist-panel>  لوحة المفضلة؛ صفوفها من قسم sedr-wishlist-drawer بأرقام المنتجات المحفوظة
 *
 * ما يفتح تبويب المفضلة: روابط صفحة المفضلة (/search?view=wishlist) في أي مكان، إلا الموسوم data-sedr-wl-page.
 * وما يفتح تبويب السلة: أيقونة السلة، والإضافة إلى السلة.
 * يعتمد على window.SedrWishlist من sedr-wishlist.js؛ إن لم يُحمَّل بقي الدرج كما في القالب.
 */
(() => {
  if (window.SedrCartTabs) return;
  window.SedrCartTabs = true;

  const start = () => {
    const W = window.SedrWishlist;
    if (!W || !W.sectionUrl || window.customElements.get('sedr-cart-tabs')) return;

    const SECTION = 'sedr-wishlist-drawer';
    const LIMIT = 24;
    const cache = new Map();
    // يزيد عند كل تغيّر في السلة، ويدخل في مفتاح القائمة فتُعاد صفوفها ولو لم يستبدل القالب اللوحة
    let stamp = 0;
    const listKey = (ids) => `${ids.join(',')}@${stamp}`;

    const getDrawer = () => document.getElementById('cart-drawer');
    const currentTab = (drawer) => (drawer && drawer.dataset.sedrTab === 'wishlist' ? 'wishlist' : 'cart');
    const savedIds = () =>
      W.items()
        .sort((a, b) => (b.t || 0) - (a.t || 0))
        .map((i) => i.id);

    // عدد المفضلة على الحبّة: إعادة رسم الدرج ترجعه إلى وسم الخادم فارغًا، فيُكتب من جديد
    const syncCount = (drawer) => {
      const badge = drawer.querySelector('sedr-cart-tabs sedr-wishlist-count');
      if (!badge) return;
      const count = W.count();
      const text = count ? String(count) : '';
      if (badge.textContent !== text) badge.textContent = text;
      if (badge.hidden !== !count) badge.hidden = !count;
    };

    /* ------------------------------------------------------------------ إفراغ السلة والتراجع */

    // ما أُفرغ يبقى في الذاكرة حتى يتراجع العميل أو يغلق الدرج أو يضيف شيئًا
    let cleared = null;
    let clearing = false;

    const cartRequest = async (path, body) => {
      const sections = [];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
      const response = await fetch(`${window.Shopify.routes.root}${path}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ ...body, sections: sections.join(',') }),
      });
      const json = await response.json();
      if (!response.ok) throw new Error(json.description || '');
      return json;
    };

    const announce = (cart, baseEvent) =>
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent, cart } }));

    const undoLine = (drawer) => {
      const tabs = drawer.querySelector(':scope > sedr-cart-tabs');
      let line = drawer.querySelector('.sedr-ct-cleared');
      // السطر في السلة الفارغة وحدها (التبويبان فيها ابن مباشر للدرج)
      const show = Boolean(cleared && tabs);
      // صف ثالث في شبكة الدرج الفارغ، فتبقى الحالة الفارغة متوسطة
      drawer.toggleAttribute('data-sedr-ct-cleared', show);
      if (!show) {
        if (line) line.remove();
        return;
      }
      if (line) return;
      line = document.createElement('p');
      line.className = 'sedr-ct-cleared text-sm';
      line.setAttribute('role', 'status');
      const text = document.createElement('span');
      text.className = 'text-subdued';
      text.textContent = tabs.dataset.cleared || '';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'link';
      button.dataset.sedrCtRestore = '';
      button.textContent = tabs.dataset.undo || '';
      line.append(text, button);
      tabs.after(line);
      // زر الإفراغ ذهب مع إعادة رسم الدرج، فالتركيز لزر التراجع
      if (!document.activeElement || document.activeElement === document.body) button.focus();
    };

    const clearCart = async (button) => {
      if (clearing) return;
      clearing = true;
      button.setAttribute('aria-busy', 'true');
      try {
        const root = window.Shopify.routes.root;
        const before = await (await fetch(`${root}cart.js`)).json();
        const items = before.items.map((item) => {
          const line = { id: item.variant_id, quantity: item.quantity };
          if (item.properties && Object.keys(item.properties).length) line.properties = item.properties;
          if (item.selling_plan_allocation) line.selling_plan = item.selling_plan_allocation.selling_plan.id;
          return line;
        });
        const cart = await cartRequest('cart/clear.js', {});
        // cart/add.js يضع آخر ما يضاف أولًا، فيُحفظ معكوسًا ليعود الترتيب كما كان
        cleared = items.reverse();
        W.track('cart_clear', { count: before.item_count });
        announce(cart, 'line-item:change');
      } catch (e) {
        button.textContent = getDrawer()?.querySelector('sedr-cart-tabs')?.dataset.failed || button.textContent;
      } finally {
        clearing = false;
        button.removeAttribute('aria-busy');
      }
    };

    const restoreCart = async (button) => {
      if (clearing || !cleared) return;
      clearing = true;
      button.setAttribute('aria-busy', 'true');
      const items = cleared;
      try {
        let added;
        try {
          added = await cartRequest('cart/add.js', { items });
        } catch (e) {
          // بند تعذّر (نفد مثلًا) يُسقط الطلب كله: يُعاد كل بند وحده، ويُترك ما تعذّر
          let done = 0;
          for (const item of items) {
            try {
              added = await cartRequest('cart/add.js', { items: [item] });
              done++;
            } catch (e2) {}
          }
          if (!done) throw e;
        }
        const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
        cart.sections = added.sections;
        cleared = null;
        W.track('cart_clear_undo', { count: cart.item_count });
        announce(cart, 'variant:add');
      } catch (e) {
        const line = button.closest('.sedr-ct-cleared');
        const text = line && line.querySelector('span');
        if (text) text.textContent = e.message || getDrawer()?.querySelector('sedr-cart-tabs')?.dataset.failed || '';
      } finally {
        clearing = false;
        button.removeAttribute('aria-busy');
      }
    };

    /* ------------------------------------------------------------------ «إضافة الكل» لذي الخيارات */

    // ما له خيارات لا يُضاف بمتغيّر يختاره السكربت: تُفتح له نافذة الاختيار في القالب نفسها، واحدًا بعد واحد،
    // والقائمة باقية تحتها. من أغلق النافذة دون إضافة تُرك منتجه. وبعد آخرها يُضاف ما له متغيّر واحد دفعة.
    // إعادة رسم السلة بعد كل إضافة تبدّل اللوحة وصفوفها، فالحالة هنا لا على اللوحة.
    let walk = null;
    let adding = false;
    const WAIT = 12000;

    // بعد إضافة من نافذة الاختيار تُنتظر اللوحة التي رسمها القالب بعد تغيّر السلة، لا التي قبلها
    const panelReady = async (after) => {
      for (let i = 0; i < 50; i++) {
        const panel = getDrawer()?.querySelector('sedr-wishlist-panel');
        const list = panel && panel.querySelector('[data-sedr-ct-list]');
        const fresh = after === undefined || stamp > after;
        if (fresh && panel && !panel.hasAttribute('aria-busy') && list && list.dataset.sedrCtKey === listKey(savedIds().slice(0, LIMIT))) return panel;
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      return null;
    };

    const walkNext = async () => {
      if (!walk || walk.moving) return;
      walk.moving = true;
      walk.current = null;
      const after = walk.after;
      walk.after = undefined;
      const panel = await panelReady(after);
      if (!walk) return;
      walk.moving = false;
      if (!panel) return void (walk = null);
      while (walk.queue.length) {
        const id = walk.queue.shift();
        const row = panel.querySelector(`.sedr-ct-item[data-product-id="${id}"]:not(.is-removed)`);
        const trigger = row && row.querySelector('[aria-controls^="quick-buy"]');
        if (!trigger) continue;
        // النافذة التي يفتحها القالب هي صاحبة هذا الرقم في الصفحة، وقد تكون في بطاقة أخرى للمنتج نفسه
        walk.current = document.getElementById(trigger.getAttribute('aria-controls')) || row.querySelector('quick-buy-drawer');
        trigger.click();
        // نافذة لم تُفتح (تعذّر جلبها) لا حدث إغلاق لها: يُنتقل إلى التالي
        const quick = walk.current;
        walk.at = Date.now();
        setTimeout(() => {
          if (walk && walk.current === quick && !(quick && quick.open)) walkNext();
        }, WAIT);
        return;
      }
      const { singles, added } = walk;
      walk = null;
      if (singles.length) panel.addIds(singles);
      else if (added) setTab('cart', 'add');
    };

    const apply = (drawer) => {
      const tab = currentTab(drawer);
      // الكتابة عند الاختلاف فقط، لأن المراقب أدناه يستدعي هذه الدالة عند كل تغيّر في الدرج
      drawer.querySelectorAll('sedr-cart-tabs [role="tab"]').forEach((button) => {
        const selected = button.dataset.sedrCtTab === tab ? 'true' : 'false';
        if (button.getAttribute('aria-selected') !== selected) button.setAttribute('aria-selected', selected);
        const index = selected === 'true' ? 0 : -1;
        if (button.tabIndex !== index) button.tabIndex = index;
      });
      syncCount(drawer);
      undoLine(drawer);
      const panel = drawer.querySelector('sedr-wishlist-panel');
      if (tab === 'wishlist' && panel && panel.refresh) panel.refresh();
    };

    // محتوى الدرج يُستبدل أو يُطابَق بما أخرجه الخادم عند كل تغيّر في السلة، فتُعاد حالة الأزرار وصفوف اللوحة
    let observed = null;
    const observe = (drawer) => {
      if (observed === drawer) return;
      observed = drawer;
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => {
          queued = false;
          apply(drawer);
        });
      }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
    };

    const setTab = (tab, source) => {
      const drawer = getDrawer();
      if (!drawer) return;
      const changed = currentTab(drawer) !== tab;
      const panel = drawer.querySelector('sedr-wishlist-panel');
      if ((changed || source === 'close') && panel && panel.tidy) panel.tidy();
      drawer.dataset.sedrTab = tab;
      apply(drawer);
      if (!changed) return;
      const body = drawer.shadowRoot && drawer.shadowRoot.querySelector('[part="body"]');
      if (body) body.scrollTop = 0;
      if (source === 'tab') {
        drawer.setAttribute('data-sedr-ct-switch', '');
        clearTimeout(drawer._sedrCtSwitch);
        drawer._sedrCtSwitch = setTimeout(() => drawer.removeAttribute('data-sedr-ct-switch'), 250);
      }
      if (tab === 'wishlist') W.track('drawer_view', { count: W.count(), source });
    };

    /* ------------------------------------------------------------------ زرّا التبويب */

    class SedrCartTabs extends HTMLElement {
      connectedCallback() {
        const drawer = this.closest('cart-drawer');
        if (!drawer) return;

        if (!this._bound) {
          this._bound = true;
          this.addEventListener('click', (event) => {
            const button = event.target.closest('[role="tab"]');
            if (button) setTab(button.dataset.sedrCtTab, 'tab');
          });
          this.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            const buttons = Array.from(this.querySelectorAll('[role="tab"]'));
            const index = buttons.indexOf(event.target.closest('[role="tab"]'));
            if (index < 0) return;
            event.preventDefault();
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + 1) % buttons.length;
            setTab(buttons[next].dataset.sedrCtTab, 'tab');
            buttons[next].focus();
          });
        }

        drawer.dataset.sedrTab = currentTab(drawer);
        drawer.setAttribute('data-sedr-tabs', '');
        // السلة الفارغة: التبويبان ابن مباشر للدرج، فيُعلَّم ليأخذا صفًّا فوق الحالة الفارغة
        drawer.toggleAttribute('data-sedr-ct-flat', this.parentElement === drawer);
        apply(drawer);
        observe(drawer);
      }
    }

    /* ------------------------------------------------------------------ لوحة المفضلة */

    class SedrWishlistPanel extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-sedr-ct-list]');
        if (!this.list) return;
        this._key = null;

        // تغيّر من خارج اللوحة (قلب في الصفحة، أو تبويب آخر في المتصفح، أو الحساب): تُعاد الصفوف
        this._onChange = () => {
          if (!this._own) this.refresh();
        };
        document.addEventListener('sedr:wishlist:change', this._onChange);

        if (!this._bound) {
          this._bound = true;
          this.addEventListener('click', (event) => this._onClick(event));
          this.addEventListener('variant:add', (event) => {
            (event.detail?.items || []).forEach((i) => W.track('item_to_cart', { productId: i.product_id, variantId: i.variant_id, source: 'cart_tab' }));
          });
        }

        this.refresh();
      }

      disconnectedCallback() {
        if (this._onChange) document.removeEventListener('sedr:wishlist:change', this._onChange);
      }

      // بعد إزالة أو تراجع من اللوحة نفسها تبقى صفوفها كما هي، ومنها سطر «تراجع»
      _settle() {
        this._key = listKey(savedIds().slice(0, LIMIT));
        const list = this.querySelector('[data-sedr-ct-list]');
        if (list) list.dataset.sedrCtKey = this._key;
        this._bulk();
      }

      // صفوف «إضافة الكل»: ما لم يُزل وما ليس في السلة أصلًا، فلا يتكرر
      _rows() {
        return Array.from(this.querySelectorAll('.sedr-ct-item:not(.is-removed):not([data-in-cart])'));
      }

      // ما له متغيّر واحد: رقمه في نموذج القالب
      _singles() {
        return this._rows()
          .map((row) => Number(row.querySelector('form input[name="id"]')?.value))
          .filter(Boolean);
      }

      // ما له خيارات وهو متوفر: أرقام منتجاته، وتُفتح لكلٍّ منها نافذة الاختيار
      _optioned() {
        return this._rows()
          .filter((row) => !row.querySelector('form input[name="id"]') && row.querySelector('[aria-controls^="quick-buy"]'))
          .map((row) => Number(row.dataset.productId))
          .filter(Boolean);
      }

      // عدد ما يشمله «إضافة الكل»: ذو المتغيّر الواحد برقمه، وذو الخيارات بالرقم الذي يضعه القالب في نافذة
      // الاختيار (handle?variant=). غير المتوفر بلا هذا ولا ذاك فلا يدخل
      _direct() {
        return this._rows()
          .map((row) => {
            const input = row.querySelector('form input[name="id"]');
            if (input && input.value) return Number(input.value);
            const quick = row.querySelector('quick-buy-drawer[handle]');
            const match = quick && /[?&]variant=(\d+)/.exec(quick.getAttribute('handle'));
            return match ? Number(match[1]) : 0;
          })
          .filter(Boolean);
      }

      _bulk() {
        const box = this._part('bulk');
        if (!box) return;
        const direct = this._direct().length;
        box.hidden = direct < 2;
        const note = this._part('bulk-note');
        if (note) note.hidden = !this._optioned().length;
        const error = this._part('bulk-error');
        if (error) error.hidden = true;
      }

      // الطلب نفسه الذي يرسله نموذج المنتج في القالب، بعدة بنود، ثم حدثا القالب ليُعاد رسم السلة والعدّاد
      _addAll() {
        // مرور بقي معلّقًا بلا نافذة مفتوحة (لم يصل حدث إغلاقها) لا يعطّل الزر
        // مرور لم تبقَ له نافذة مفتوحة ولا نافذة تُجلب لا يحبس الزر
        if (walk && !walk.moving && !(walk.current && (walk.current.open || Date.now() - walk.at < WAIT))) walk = null;
        if (adding || walk) return;
        const queue = this._optioned();
        const singles = this._singles();
        if (!queue.length) return this.addIds(singles);
        walk = { queue, singles, added: false };
        walkNext();
      }

      async addIds(ids) {
        const button = this._part('add-all');
        if (adding || !ids.length || !button) return;
        adding = true;
        button.setAttribute('aria-busy', 'true');
        const error = this._part('bulk-error');
        if (error) error.hidden = true;
        const root = window.Shopify.routes.root;
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
        try {
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: ids.map((id) => ({ id, quantity: 1 })), sections: sections.join(',') }),
          });
          const added = await response.json();
          if (!response.ok) throw new Error(added.description || '');
          const cart = await (await fetch(`${root}cart.js`)).json();
          cart.sections = added.sections;
          W.track('add_all_to_cart', { count: ids.length, source: 'cart_tab' });
          (this.isConnected ? this : document.documentElement).dispatchEvent(
            new CustomEvent('variant:add', { bubbles: true, detail: { items: added.items || [added], cart } })
          );
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
        } catch (e) {
          if (error) {
            error.textContent = e.message || error.dataset.fallback;
            error.hidden = false;
          }
        } finally {
          adding = false;
          button.removeAttribute('aria-busy');
        }
      }

      // عند إغلاق الدرج أو مغادرة التبويب: تُرفع أسطر «تراجع»، ويُعاد الطلب إن كان قد تعذّر
      tidy() {
        this._emptied = null;
        const emptied = this._part('emptied');
        if (emptied) emptied.hidden = true;
        this.querySelectorAll('.sedr-ct-item.is-removed').forEach((row) => row.remove());
        const list = this.querySelector('[data-sedr-ct-list]');
        if (this._failed || (list && !list.children.length)) this._key = null;
        this._failed = false;
      }

      _part(name) {
        return this.querySelector(`[data-sedr-ct-${name}]`);
      }

      _show(nodes, total, failed) {
        this.removeAttribute('aria-busy');
        this.list = this.querySelector('[data-sedr-ct-list]') || this.list;
        // «في السلة» في موضع زر الإضافة، والزر نفسه يخفيه التنسيق فلا يتكرر المنتج
        nodes.forEach((node) => {
          const mark = node.querySelector(':scope > [data-sedr-ct-incart]');
          const info = node.querySelector('.horizontal-product__info');
          if (mark && info) info.append(mark);
        });
        this.list.replaceChildren(...nodes);
        // علامة على أن هذه القائمة رُسمت بهذا المفتاح؛ تزول إن أعاد القالب رسم اللوحة
        this.list.dataset.sedrCtKey = this._key || '';
        const none = !nodes.length;
        const set = (name, visible) => {
          const el = this._part(name);
          if (el) el.hidden = !visible;
        };
        set('empty', none && !failed && total === 0);
        set('gone', none && !failed && total > 0);
        set('error', !!failed);
        set('all', total > 0);
        set('wipe', !none);
        set('emptied', !!this._emptied);
        this._bulk();
      }

      // تُرسم عند فتح تبويب المفضلة فقط، فلا طلب لمن لا يفتحه
      async refresh() {
        const drawer = this.closest('cart-drawer');
        if (!this.list || !drawer || currentTab(drawer) !== 'wishlist') return;

        const all = savedIds();
        const ids = all.slice(0, LIMIT);
        const key = listKey(ids);
        const list = this.querySelector('[data-sedr-ct-list]');
        if (key === this._key && list && list.dataset.sedrCtKey === key) return;
        // طلب جارٍ بهذا المفتاح: لا يُكرَّر، فالمراقب يستدعي هذه الدالة عند كل تغيّر في الدرج
        this._key = key;
        if (key === this._pending) return;

        if (!ids.length) return this._show([], 0);

        const url = W.sectionUrl(ids, SECTION);
        let html = cache.get(url);
        if (!html) {
          if (!list || !list.children.length) this.setAttribute('aria-busy', 'true');
          this._pending = key;
          const asked = stamp;
          try {
            const response = await W.request(url);
            if (!response.ok) throw new Error(String(response.status));
            html = await response.text();
            if (asked === stamp) cache.set(url, html);
            this._pending = null;
          } catch (e) {
            this._pending = null;
            // المفتاح يبقى فلا يُعاد الطلب عند كل تغيّر في الدرج؛ يُعاد عند فتح التبويب من جديد
            if (this._key === key && this.isConnected) {
              this._failed = true;
              this._show([], all.length, true);
            }
            return;
          }
        }
        if (this._key !== key || !this.isConnected) return;

        const found = new Map();
        new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelectorAll('.sedr-ct-item')
          .forEach((el) => found.set(Number(el.dataset.productId), el));
        const nodes = ids.filter((id) => found.has(id)).map((id) => document.importNode(found.get(id), true));
        this._show(nodes, all.length);
      }

      _onClick(event) {
        const addAll = event.target.closest('[data-sedr-ct-add-all]');
        if (addAll) return this._addAll(addAll);

        // إفراغ المفضلة: تُحفظ عناصرها في الذاكرة ليعيدها «تراجع» بترتيبها
        if (event.target.closest('[data-sedr-ct-wipe]')) {
          const items = W.items();
          this.querySelectorAll('.sedr-ct-item.is-removed').forEach((row) => row._removed && items.push(row._removed));
          if (!items.length) return;
          this._own = true;
          W.clear();
          this._own = false;
          this._emptied = items;
          W.track('clear', { count: items.length, source: 'cart_tab' });
          this._key = '';
          this._show([], 0);
          return void this._part('refill')?.focus();
        }
        if (event.target.closest('[data-sedr-ct-refill]') && this._emptied) {
          const items = this._emptied;
          this._emptied = null;
          this._own = true;
          items.forEach((item) => W.restore(item));
          this._own = false;
          this._key = null;
          this.refresh();
          return void getDrawer()?.querySelector('[data-sedr-ct-tab="wishlist"]')?.focus();
        }
        const row = event.target.closest('.sedr-ct-item');
        if (!row || !this.contains(row)) return;
        const undoLine = row.querySelector('.sedr-ct-item__undo');

        if (event.target.closest('[data-sedr-ct-remove]')) {
          this._own = true;
          const removed = W.remove(Number(row.dataset.productId));
          this._own = false;
          this._settle();
          if (!removed || !undoLine) return row.remove();
          W.track('remove', { productId: removed.id, source: 'cart_tab' });
          row._removed = removed;
          row.classList.add('is-removed');
          undoLine.hidden = false;
          undoLine.querySelector('[data-sedr-ct-undo]')?.focus();
        } else if (event.target.closest('[data-sedr-ct-undo]') && row._removed) {
          this._own = true;
          const restored = W.restore(row._removed);
          this._own = false;
          this._settle();
          if (!restored) return;
          row._removed = null;
          row.classList.remove('is-removed');
          if (undoLine) undoLine.hidden = true;
          row.querySelector('[data-sedr-ct-remove]')?.focus();
        }
      }
    }

    window.customElements.define('sedr-wishlist-panel', SedrWishlistPanel);
    window.customElements.define('sedr-cart-tabs', SedrCartTabs);

    /* ------------------------------------------------------------------ ما يفتح كل تبويب */

    const isWishlistLink = (link) => {
      try {
        const url = new URL(link.href, window.location.href);
        return (
          url.origin === window.location.origin &&
          /\/search\/?$/.test(url.pathname) &&
          url.searchParams.get('view') === 'wishlist' &&
          !url.searchParams.has('shared')
        );
      } catch (e) {
        return false;
      }
    };

    // الدرج يُفتح بدل الصفحة حيث تفتحه أيقونة السلة نفسها، ولا يُعترض الرابط في صفحة المفضلة ولا صفحة السلة
    const drawerUsable = (drawer) => {
      const settings = (window.themeVariables && window.themeVariables.settings) || {};
      return (
        !!drawer &&
        typeof drawer.show === 'function' &&
        drawer.hasAttribute('data-sedr-tabs') &&
        settings.cartType !== 'page' &&
        settings.pageType !== 'cart' &&
        !document.querySelector('sedr-wishlist-page')
      );
    };

    document.addEventListener(
      'click',
      (event) => {
        if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        const drawer = getDrawer();

        const clear = target.closest('[data-sedr-ct-clear]');
        if (clear) return void clearCart(clear);
        const restore = target.closest('[data-sedr-ct-restore]');
        if (restore) return void restoreCart(restore);

        // أيقونة السلة: القالب يفتح الدرج، وهنا يُضبط التبويب قبل فتحه
        const control = target.closest('[aria-controls="cart-drawer"]');
        if (control) {
          if (drawer && !drawer.open) setTab(control.dataset.sedrCtTab === 'wishlist' ? 'wishlist' : 'cart', 'control');
          return;
        }

        const link = target.closest('a[href]');
        if (!link || link.hasAttribute('data-sedr-wl-page') || link.target === '_blank') return;
        if (!isWishlistLink(link) || !drawerUsable(drawer)) return;

        event.preventDefault();
        // نافذة أخرى مفتوحة فيها الرابط (قائمة الجوال مثلًا) تُغلق أولًا
        const host = link.closest('[role="dialog"][open]');
        if (host && host !== drawer && typeof host.hide === 'function') host.hide();
        setTab('wishlist', 'link');
        if (!drawer.open) drawer.show();
        // شريط التنقل السفلي يعلّم الرابط «ذاهب» حتى تتغير الصفحة، والصفحة هنا لا تتغير
        setTimeout(() => link.classList.remove('is-going'), 0);
      },
      true
    );

    document.addEventListener('sedr:wishlist:change', () => {
      const drawer = getDrawer();
      if (drawer) syncCount(drawer);
    });

    // الإضافة إلى السلة تعرض السلة دائمًا، ومنها الإضافة من تبويب المفضلة
    // علامة «في السلة» من الخادم، فما حُفظ من الصفوف يبطل عند كل تغيّر في السلة
    // وفي طور الالتقاط، قبل أن يعيد القالب رسم الدرج فتطلب اللوحة الجديدة صفوفها
    const cartMoved = () => {
      cache.clear();
      stamp++;
    };
    document.addEventListener('cart:change', cartMoved, true);
    document.addEventListener('cart:refresh', cartMoved, true);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) cartMoved();
    });

    document.addEventListener('variant:add', (event) => {
      cleared = null;
      // في أثناء «إضافة الكل» يبقى تبويب المفضلة حتى ينتهي المرور على ذوات الخيارات
      if (walk) {
        // بالمسار لا بـcontains: النافذة تستبدل محتواها عند الإضافة فيخرج النموذج منها قبل وصول الحدث إلى هنا
        if (walk.current && event.composedPath().includes(walk.current)) {
          // تُغلق نافذة الاختيار ويُنتقل إلى التالي
          const quick = walk.current;
          walk.added = true;
          walk.after = stamp;
          walkNext();
          if (typeof quick.hide === 'function') quick.hide();
        }
        return;
      }
      setTab('cart', 'add');
    });

    // بعد الإغلاق يعود الدرج إلى السلة، فلا يفتحه على المفضلة إلا من طلبها
    document.addEventListener('dialog:after-hide', (event) => {
      const drawer = getDrawer();
      // نافذة اختيار أُغلقت دون إضافة في أثناء «إضافة الكل»: يُترك منتجها ويُنتقل إلى التالي
      if (walk && walk.current && event.target === walk.current) return void walkNext();
      if (!drawer || event.target !== drawer || drawer.open) return;
      walk = null;
      cleared = null;
      undoLine(drawer);
      setTab('cart', 'close');
    });
  };

  // ملف المفضلة يُحمَّل من رأس الصفحة بـdefer مثل هذا الملف، وأيهما سبق فالآخر جاهز عند DOMContentLoaded
  if (window.SedrWishlist) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
